import {Elements} from "@stripe/react-stripe-js";
import React from "react";
import {loadStripe} from "@stripe/stripe-js";
import {BotCheckoutForm} from "./BotCheckoutForm";
import {Message, stripePublicKeySelector} from "../../chatbotSlice";
import {useAppSelector} from "../../../app/hooks";

const options = {
    amount: 14900,
    currency: "gbp",
    mode: "payment",
    // Fully customizable with appearance API.
    appearance: {
        readOnly: true,
        theme: "flat",
        variables: {
            fontFamily: ' "Gill Sans", sans-serif',
            fontLineHeight: "1.5",
            borderRadius: "10px",
            colorBackground: "#F6F8FA",
            accessibleColorOnColorPrimary: "#262626",
        },
        rules: {
            ".Block": {
                backgroundColor: "var(--colorBackground)",
                boxShadow: "none",
                padding: "12px",
            },
            ".Input": {
                padding: "12px",
                borderRadius: "9999px",
                backgroundColor: "#f6f6f6",
                boxSizing: "border-box",
                borderWidth: "2px",
                borderStyle: "solid",
                borderColor: "#eeeeee",
                color: "black",
            },
            ".Input:disabled, .Input--invalid:disabled": {
                color: "lightgray",
            },
            ".Tab": {
                padding: "10px 12px 8px 12px",
                border: "none",
            },
            ".Tab:hover": {
                border: "none",
                boxShadow:
                    "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
            },
            ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {
                border: "none",
                backgroundColor: "#fff",
                boxShadow:
                    "0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
            },
            ".Label": {
                fontWeight: "500",
            },
        },
    },
};

interface BotCheckoutFormWrapperProps {
    message: Message
}

export const BotCheckoutFormWrapper: React.FC<BotCheckoutFormWrapperProps> = ({message}) => {

    const stripePublicKey = useAppSelector(stripePublicKeySelector)

    return <Elements
        // @ts-ignore
        stripe={loadStripe(stripePublicKey)}
        // @ts-ignore
        options={options}
    >
        <BotCheckoutForm message={message}/>
    </Elements>
};
